var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('uax-editor',{attrs:{"id":"tresc","value":_vm.tresc},on:{"input":val => _vm.$emit('update:tresc', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }